import React, { useEffect, useState } from 'react';

function ResponsiveShadow({ children, className = '', style = {} }) {
  const [maxHeight, setMaxHeight] = useState('calc(100vh - 130px)');

  useEffect(() => {
    function handleResize() {
      computeMaxHeight();
    }

    function computeMaxHeight() {
      try {
        const header = document.querySelector('.navbar');
        const footer = document.querySelector('footer.footer') || document.querySelector('footer');
        const headerBottom = header ? header.getBoundingClientRect().bottom : 80;
        const footerTop = footer ? footer.getBoundingClientRect().top : window.innerHeight - 40;
        const available = Math.floor(footerTop - headerBottom - 25);
        setMaxHeight(`${Math.max(160, available)}px`);
      } catch (e) {
        setMaxHeight('calc(100vh - 130px)');
      }
    }

    computeMaxHeight();
    window.addEventListener('resize', handleResize);
    const mo = new MutationObserver(computeMaxHeight);
    mo.observe(document.body, { childList: true, subtree: true, attributes: true });
    return () => {
      window.removeEventListener('resize', handleResize);
      mo.disconnect();
    };
  }, []);

  const defaultStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.92)',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
    maxHeight: maxHeight,
    overflow: 'hidden',
    borderRadius: '0.75rem',
    ...style,
  };

  const defaultClassName = `mt-0 mb-0 p-0 ${className}`;

  return (
    <div
      className={`${defaultClassName} shadow-lg rounded-3`}
      style={defaultStyle}
    >
      {children}
    </div>
  );
}

export default ResponsiveShadow;
